@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--dark-4);
  border-radius: 6px;
  min-height: 32px;
  padding: 6px;
  width: 245px;

  &.focused {
    width: calc(465px - 32px - 6px - 12px); // - submit button - padding - gap
    background: none;
    box-shadow: inset 0 0 0 2px var(--selected-stroke);
  }
}

.textarea {
  background: none;
  @include sm-sohne;
  @include hide-scrollbar;
  flex: 1;
  height: 20px;
  width: 100%;
  resize: none;
  color: var(--dark-80);
}

.sendButton {
  align-self: end;
}
